import React, { useEffect, useMemo, useState } from "react";
import CustomStepper from "../Component/CustomStepper";
import { Typography } from "@mui/material";
import APP_CONSTANTS, { MESSAGES } from "../../../utils/config";
import { useTheme } from "@emotion/react";
import EditableInfraPage from "./EditableInfraPage";
import EditableCostApprovalPage from "./EditableCostApprovalPage";
import Error from "../Component/Error";
import {
  fetchRapdidRegisterTemplate,
  fetchRapidApplication,
} from "../../../services/api";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import { useDispatch } from "react-redux";
import {
  updateRapidAppStatus,
  updateRapidDetailsData,
  updateRapidInfraData,
  updateTotalCostData,
  updateAIModelsJsonData,
  updateAccLibraryJsonData,
} from "../../../redux/slice/dataSlice";
import Loader from "../../../components/Loader/Loader";
import { useSelector } from "react-redux";
import EditableDetailsPage from "./EditableDetailsPage";
import { useNavigate, useParams } from "react-router-dom";
import PageNotFound from "../../NoAccess/NoAccess";
import EditableChooseAIModel from "./EditableChooseAIModel";
import AcceleratorLibraryPage from "./AcceleratorLibraryPage";
import { normalizeList } from "../../../utils/utils";

function sortDetailsData(detailsJson) {
  const category2 = detailsJson[1]["resources"] || [];
  category2?.map((item) => {
    return {
      ...item,
      options: item.options.sort((a, b) => a.name.localeCompare(b.name)),
    };
  });
}
function EditRapidFinishedContainer() {
  const param = useParams();
  const register_id = param?.id || "";

  const appStatus =
    useSelector((state) => state.data.rapidData?.current_status) || "";

  const [activeStep, setActiveStep] = useState(
    appStatus === APP_CONSTANTS.RAPID_STATUS.TECHNICAL_OWNER_RESPONSE_PENDING
      ? 1
      : 0
  );

  const [infraPageBackup, setInfraPageBackup] = useState([]);
  const [loading, setLoading] = useState({
    status: "loading",
    message: "Registering Application loading",
  });
  const dispatch = useDispatch();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  // const appStatus = useMemo(() => {
  //   if (register_id !== "") {
  //     return APP_CONSTANTS?.RAPID_STATUS?.TECHNICAL_OWNER_RESPONSE_PENDING;
  //   } else {
  //     return APP_CONSTANTS?.RAPID_STATUS?.PENDING_INFORMATION;
  //   }
  // }, []);

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const is_admin =
    useSelector((state) => state.auth.metadata?.rapid?.is_admin) || false;

  const isRapidAccess = useSelector(
    (state) => state.auth.metadata?.rapid?.access || false
  );

  const theme = useTheme();
  const userEmail = useSelector((state) => state.auth?.metadata?.email);
  let total_cost = useSelector((state) => state.data.rapidData?.total_cost);
  total_cost = total_cost === "loading" ? "..." : "$ " + total_cost.toFixed(2);

  const steps = [
    {
      id: "Request Details",
      name: "Request Details",
    },
    {
      id: "Project Type And Components",
      name: "Project Type And Components",
    },
    {
      id: "Accelerator Libraries",
      name: "Accelerator Libraries",
    },
    {
      id: "Choose AI Model",
      name: "Choose AI Model",
    },
    {
      id: "Total Cost",
      name: `Total Cost (${total_cost})`,
    },
  ];
  const navigate = useNavigate();

  const getEditableData = async () => {
    setLoading({
      status: "loading",
      message: "Registering Application loading",
    });

    try {
      const resp = await fetchRapidApplication({
        params: {
          register_id: register_id,
        },
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        const data = resp.data?.data;
        // Ensure LeanIX id and Gen AI options are present in Project Type & Components
        let infra =
          data?.infraResources || data?.infra_details || data?.infrajson;
        // try {
        //   if (
        //     Array.isArray(infra) &&
        //     infra[1] &&
        //     Array.isArray(infra[1].components)
        //   ) {
        const comps = infra[1].components;

        const hasLeanIX = comps.some(
          (c) => (c?.component_name || "").toLowerCase() === "leanix id"
        );
        const hasGenAI = comps.some((c) => c?.component_id === 35);
        const updatedComps = [...comps];
        if (!hasLeanIX) {
          updatedComps.splice(0, 0, {
            component_id: 34,
            component_name: "LeanIX id",
            component_type: "input",
            description: "LeanIX id ",
            info: "Application domain name where It can be accessed by users / web address or endpoint used to access an application,",
            is_required: true,
            properties: [
              {
                cost: 0,
                input_class: "text",
                max_value: "255",
                min_value: "1",
                placeholder_text: "Enter LeanIX id ",
                property_id: 5,
                property_value: null,
              },
            ],
            value: null,
          });
        } else {
          // Update existing LeanIX field to be required
          const leanixIndex = updatedComps.findIndex(
            (c) => (c?.component_name || "").toLowerCase() === "leanix id"
          );
          if (leanixIndex !== -1) {
            updatedComps[leanixIndex] = {
              ...updatedComps[leanixIndex],
              is_required: true,
            };
          }
        }
        if (!hasGenAI) {
          const updatedComps = [...comps];
          updatedComps.splice(2, 0, {
            component_id: 35,
            component_name: "Gen AI options",
            component_type: "multi-select-dropdown",
            description: "Select Gen AI model options",
            info: "",
            is_required: false,
            properties: [],
            value: [],
          });
          infra = [
            ...infra.slice(0, 1),
            { ...infra[1], components: updatedComps },
            ...infra.slice(2),
          ];
        } else {
          const genAIComponent = updatedComps.filter(
            (item) => item.component_id === 35
          );
          let propertyList = genAIComponent[0]?.properties;
          let propertyListModified = propertyList.map((item) => {
            return {
              ...item,
              cost: item?.cost ? item.cost : 0,
              score: item?.score ? item.score : 0,
            };
          });
          const valueList = genAIComponent[0]?.value;
          const valueListModified = normalizeList(
            valueList,
            propertyListModified
          );
          const modifiedComponents = updatedComps.map((item) => {
            if (item.component_id === 35) {
              return {
                ...item,
                properties: propertyListModified,
                value: valueListModified,
              };
            } else {
              return item;
            }
          });
          infra = [
            ...infra.slice(0, 1),
            { ...infra[1], components: modifiedComponents },
            ...infra.slice(2),
          ];
        }
        dispatch(updateRapidInfraData(infra));
        setInfraPageBackup(infra);
        dispatch(updateRapidDetailsData(data?.details));
        data?.choose_ai_models === null ||
        data?.choose_ai_models?.length === 0 ||
        Object.keys(data?.choose_ai_models)?.length <= 3
          ? dispatch(
              updateAIModelsJsonData({
                usecases: [],
                priority_1: "",
                priority_2: "",
                priority_3: "",
              })
            )
          : dispatch(updateAIModelsJsonData(data?.choose_ai_models));
        dispatch(updateAccLibraryJsonData(data?.accelerator_libraries || {}));
        dispatch(updateRapidAppStatus(data?.status || ""));
        setLoading({
          status: "success",
          message: message,
        });
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
        setLoading({
          status: "error",
          message: message,
        });
      }
    } catch (err) {
      console.error("Error", err);
      setLoading({
        status: "error",
        message: "Internal Server Error",
      });
    }
  };

  useEffect(() => {
    if (!isRapidAccess) return;
    if (register_id !== "") {
      getEditableData();
    }

    return () => {
      dispatch(updateTotalCostData("loading"));
    };
  }, []);

  const getComponent = (stepperIndex) => {
    // eslint-disable-next-line
    switch (stepperIndex) {
      case 0:
        return (
          <EditableDetailsPage
            isRegistering={false}
            userEmail={userEmail}
            register_id={register_id}
            handleNext={handleNext}
          />
        );
      case 1:
        return (
          <EditableInfraPage
            isRegistering={true}
            userEmail={userEmail}
            register_id={register_id || ""}
            appStatus={appStatus}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );
      case 2:
        return (
          <AcceleratorLibraryPage
            register_id={register_id || ""}
            handleNext={handleNext}
            handleBack={handleBack}
            isRegistering={true}
          />
        );
      case 3:
        return (
          <EditableChooseAIModel
            handleNext={handleNext}
            handleBack={handleBack}
            isRegistering={true}
          />
        );

      case 4:
        return (
          <EditableCostApprovalPage
            handleBack={handleBack}
            infraPageBackup={infraPageBackup}
            isRegistering={true}
            userEmail={userEmail}
            appOwners={[]}
            register_id={register_id || ""}
            status={appStatus}
            is_admin={is_admin}
          />
        );
    }
  };
  return (
    <>
      {!isRapidAccess ? (
        <PageNotFound />
      ) : (
        <div style={{ margin: theme.size[24], height: "calc(100vh - 105px)" }}>
          {/* Header */}
          <Typography
            sx={{
              fontWeight: theme.fontWeight[500],
              fontSize: theme.size[15],
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "calc(100vw - 460px)",
              color: theme.palette.primary.darkViolet,
            }}
          >
            {MESSAGES.RAPID}
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              margin: "8px 0 16px 0",
            }}
          >
            <Typography
              sx={{
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
                color: theme.palette.primary.darkViolet,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/rapid");
              }}
            >
              RAPID
            </Typography>
            <Typography
              sx={{
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
                color: theme.palette.secondary.main,
                margin: "0 5px",
              }}
            >
              /
            </Typography>
            <Typography
              sx={{
                fontWeight: theme.fontWeight[500],
                fontSize: theme.size[14],
                color: theme.palette.primary.darkViolet,
                opacity: 0.5,
              }}
            >
              {register_id !== "" ? register_id : "Request New Application"}
            </Typography>
          </div>

          {/* Stepper */}
          <div
            style={{
              width: "90%",
            }}
          >
            <CustomStepper steps={steps} activeStep={activeStep} />
          </div>

          {/* Main Component */}
          {loading.status === "loading" ? (
            <Loader />
          ) : loading.status === "success" ? (
            <div
              style={{
                marginTop: theme.size[24],
                height: "calc(100vh - 210px)",
                position: "relative",
              }}
            >
              {getComponent(activeStep)}
            </div>
          ) : (
            <Error
              message={loading.message}
              imageHeight={"20vh"}
              height={"80%"}
              retryFunction={getEditableData}
            />
          )}
        </div>
      )}
    </>
  );
}

export default EditRapidFinishedContainer;
